<template lang="pug">
div
  el-row
    el-col(v-if="!isPessoaFisica", :span="12")
      app-display(
        label="CNPJ:",
        :content="interessado.pessoa.pessoaJuridica.cnpj",
        :class = "compararInteressadoAreasPatrimoniais && compararInteressadoAreasPatrimoniais.mudouPessoa.mudouCNPJ ? 'text': '' "
      )
      app-display(
        label="Prefeitura:",
        :content="interessado.pessoa.pessoaJuridica.razaoSocial",
        :class = "compararInteressadoAreasPatrimoniais && compararInteressadoAreasPatrimoniais.mudouPessoa.mudouRazaoSocial ? 'text': '' "
      )
    el-col(v-if="isPessoaFisica", :span="12")
      app-display(
        label="CPF do Prefeito:",
        :content="interessado.pessoa.pessoaFisica.cpf",
        :class = "compararInteressadoAreasPatrimoniais && compararInteressadoAreasPatrimoniais.mudouPessoa.mudouCPF ? 'text': '' "
      )
      app-display(
        label="Nome do Prefeito:",
        :content="interessado.pessoa.pessoaFisica.nome",
        :class = "compararInteressadoAreasPatrimoniais && compararInteressadoAreasPatrimoniais.mudouPessoa.mudouNome ? 'text': '' "
      )
  el-row
    el-col
      app-collapse(title="Endereço")
        informacoes-endereco(:endereco="enderecoInteressado",  slot="body", :mudouEndereco="compararInteressadoAreasPatrimoniais && compararInteressadoAreasPatrimoniais.mudouEndereco")

</template>

<script>
import AppDisplay from '@/components/AppDisplay'
import AppCollapse from '@/components/AppCollapse'

import InformacoesEndereco from '@/components/informacoesCadastro/common/InformacoesEndereco'

export default {
  props: {
    interessado: {
      type: Object,
      required: true
    },
    compararInteressadoAreasPatrimoniais: {
      type: Object,
      required: true
    }
  },
  components: {
    InformacoesEndereco,
    AppDisplay,
    AppCollapse
  },

  computed: {
    enderecoInteressado () {
      return this.interessado.pessoa.endereco ? this.interessado.pessoa.endereco : {}
    },

    isPessoaFisica () {
      return this.interessado?.pessoa?.pessoaFisica
    }
  }

}
</script>
<style lang="scss" scoped>
  >>> .text .text{
    color: #ff0000 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/cadastrosOnline/areasPatrimoniais/InformacoesInteressadoAreasPatrimoniais.vue